module.exports = __webpack_public_path__ + "img/album_pro.7dd5b3cf.jpg";